import { render, staticRenderFns } from "./jududatepicker.vue?vue&type=template&id=72b5d8aa&scoped=true&"
import script from "./jududatepicker.vue?vue&type=script&lang=js&"
export * from "./jududatepicker.vue?vue&type=script&lang=js&"
import style0 from "./jududatepicker.vue?vue&type=style&index=0&id=72b5d8aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b5d8aa",
  null
  
)

export default component.exports